import portrait from "../assets/images/prof-pics.png";
export function About() {
  return (
    <section id="about" className="about-section">
      <div className="shell about-grid">
        <div data-reveal>
          <span className="eyebrow">02 / A LITTLE ABOUT ME</span>
          <div className="portrait-frame">
            <img
              src={portrait}
              alt="Portrait of Emmanuel Adegbulu, Fabulous J"
              loading="lazy"
              width="480"
              height="600"
            />
            <span className="portrait-caption">
              FABULOUS J / EMMANUEL A. ADEGBULU
            </span>
          </div>
        </div>
        <div className="about-copy" data-reveal>
          <h2>
            Good software
            <br />
            starts with
            <br />
            <em>understanding.</em>
          </h2>
          <p className="large-copy">
            I’m Emmanuel (Fabulous J), a software engineer working across
            frontend and full-stack development.
          </p>
          <p>
            I work with JavaScript and PHP ecosystems to build products that
            people use to manage properties, maintain facilities, and run
            commerce operations.
          </p>
          <p>
            My approach is practical: understand the workflow, make the
            interface clear, and build reusable foundations. I care about the
            API contract as much as the screen, and I’m comfortable working
            through the details with designers and backend engineers.
          </p>
          <a href="/Resume.pdf" className="text-link" download>
            More about my background <span aria-hidden="true">↗</span>
          </a>
          <div className="about-notes">
            <span>
              <b>Frontend</b>Architecture & interfaces
            </span>
            <span>
              <b>Full-stack</b>APIs & integration
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
